import { makeStyles } from 'tss-react/mui';

const useStylesSinglePageBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  singlePageBlock: {
    minHeight: 'calc(100vh - 310px)',
  },
  singlePageBlockDark: {
    backgroundColor: theme.palette.primary.light,
  },
  singlePageBlockNoTabsOffset: {
    minHeight: 'calc(100vh - 260px)',
  },
  singlePageBlockScrollable: {
    maxHeight: 'calc(100vh - 310px)',
  },
  singlePageBlockScrollableNoTabsOffset: {
    maxHeight: 'calc(100vh - 260px)',
  },
  singlePageBlockFullHeight: {
    maxHeight: 'none',
  },
}));

export default useStylesSinglePageBlock;
